import React, { useEffect, useCallback, useState } from 'react';
import { compose } from 'redux';
import { useParams, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  PageLayout,
  PageContentPreloader,
  DefaultButton,
  ActionsButton,
  StatusCell,
  DateCell,
  BasicModal,
} from 'common/components';
import { FormattedMessage } from 'react-intl';
import { withTheme } from 'common/styling/theme';
import { CopyIcon } from 'common/icons';
import { boGetUserChallenge, boIncreaseUserChallenge } from '../../_redux';
import { staticStyles, getDynamicStyles } from './style';
import CloseChallengeForm from '../../_components/CloseChallengeForm';

const BoUserChallengePage = ({
  history,
  getUserChallenge,
  userChallenge,
  userChallengeAreLoaded,
  theme,
  perms,
  increaseStage,
}) => {
  const { challengeId } = useParams();
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;

  const [isMailCopied, setIsMailCopied] = useState(false);
  const [isIncreaseModalOpened, setIsIncreaseModalOpened] = useState(false);
  const [isCloseModalOpened, setIsCloseModalOpened] = useState(false);

  useEffect(() => {
    getUserChallenge(challengeId);
  }, [challengeId, getUserChallenge]);

  const toggleIncreaseModal = () => {
    setIsIncreaseModalOpened(isOpen => !isOpen);
  };

  const toggleCloseModal = () => {
    setIsCloseModalOpened(isOpen => !isOpen);
  };

  const handleBackToClick = useCallback(() => {
    history.push('/backoffice/proptrading');
  }, [history]);

  const handleMailCopyClick = useCallback(
    email => {
      navigator.clipboard.writeText(email);
      setIsMailCopied(true);

      setTimeout(() => {
        setIsMailCopied(false);
      }, 2000);
    },
    [isMailCopied]
  );

  const handleIncreaseStage = () => {
    increaseStage(challengeId);
    toggleIncreaseModal();
  };

  return (
    <PageLayout
      captionSlug="boChallenge"
      showReload
      onReloadClick={() => getUserChallenge(challengeId)}
      reloading={!userChallengeAreLoaded}>
      <PageContentPreloader ready={userChallengeAreLoaded} type="boPaymentPage">
        {/* eslint-disable */}
        <FormattedMessage id="backToAllChallenges">
          {txt => (
            <div className="BoUserChallengePage__back-to" onClick={handleBackToClick}>
              {txt}
            </div>
          )}
        </FormattedMessage>
        {/* eslint-enable */}

        <div className="BoUserChallengePage-info">
          <ul className="BoUserChallengePage__top-info-list">
            <li className="BoUserChallengePage__top-info-item">
              <span>ID</span>
              <div>{userChallenge?.id}</div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>User</span>
              <div>
                {userChallenge?.user}
                <ActionsButton
                  tooltipId="email-copy-tooltip"
                  tooltipTextId={isMailCopied ? 'justCopiedWord' : 'justCopy'}
                  edit
                  buttonId="actionsCopyValue"
                  onClickFunc={() => handleMailCopyClick(userChallenge?.user)}>
                  <CopyIcon />
                </ActionsButton>
              </div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Title</span>
              <div>{userChallenge?.title}</div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Challenge</span>
              <div>{userChallenge?.challenge}</div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Status</span>
              <div>
                <StatusCell statusCode={userChallenge?.status} />
              </div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Account</span>
              <div>{userChallenge?.account}</div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Withdraw Account</span>
              <div>{userChallenge?.withdrawAccount || 'wallet'}</div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Stage</span>
              <div>{userChallenge?.stage}</div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Target</span>
              <div>
                {userChallenge?.target?.amount} {userChallenge?.target?.currency}
              </div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Initial Balance</span>
              <div>
                {userChallenge?.initialAccountBalance?.amount} {userChallenge?.initialAccountBalance?.currency}
              </div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Maximum Loss Total</span>
              <div>
                {userChallenge?.maximumLossTotal?.amount} {userChallenge?.maximumLossTotal?.currency}
              </div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Maximum Daily Loss</span>
              <div>
                {userChallenge?.maximumDailyLoss?.amount} {userChallenge?.maximumDailyLoss?.currency}
              </div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Profit Target</span>
              <div>
                {userChallenge?.profitTarget?.amount} {userChallenge?.profitTarget?.currency}
              </div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Last Equity</span>
              <div>
                {userChallenge?.lastEquity?.amount} {userChallenge?.lastEquity?.currency}
              </div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Last Profit</span>
              <div>
                {userChallenge?.lastProfit?.amount} {userChallenge?.lastProfit?.currency}
              </div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Total Profit</span>
              <div>
                {userChallenge?.totalProfit?.amount} {userChallenge?.totalProfit?.currency}
              </div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Daily Profit</span>
              <div>
                {userChallenge?.dailyProfit?.amount} {userChallenge?.dailyProfit?.currency}
              </div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Maximum Loss Today</span>
              <div>
                {userChallenge?.maximumLossToday?.amount} {userChallenge?.maximumLossToday?.currency}
              </div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Maximum Profit Today</span>
              <div>
                {userChallenge?.maximumProfitToday?.amount} {userChallenge?.maximumProfitToday?.currency}
              </div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Maximum Profit Total</span>
              <div>
                {userChallenge?.maximumProfitTotal?.amount} {userChallenge?.maximumProfitTotal?.currency}
              </div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Maximum Total Loss</span>
              <div>
                {userChallenge?.maximumTotalLoss?.amount} {userChallenge?.maximumTotalLoss?.currency}
              </div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Created</span>
              <div>{userChallenge?.created && <DateCell value={userChallenge?.created} />}</div>
            </li>

            <li className="BoUserChallengePage__top-info-item">
              <span>Updated</span>
              <div>{userChallenge?.updated && <DateCell value={userChallenge?.updated} />}</div>
            </li>
          </ul>

          {userChallenge?.status !== 'failed' && (
            <div className="BoUserChallengePage__buttons-inner">
              {perms.proptradingStageIncreasePerm && (
                <DefaultButton type="button" textId="increaseStage" filled onClick={toggleIncreaseModal} />
              )}
              {perms.proptradingCloseChallengePerm && (
                <DefaultButton type="button" textId="closeChallenge" onClick={toggleCloseModal} />
              )}
            </div>
          )}
        </div>

        <BasicModal captionId="increaseStage" isOpen={isIncreaseModalOpened} onRequestClose={toggleIncreaseModal}>
          <FormattedMessage id="increaseChallengeWarning">{txt => txt}</FormattedMessage>
          <div className="BoUserChallengePage__increase-modal-buttons">
            <DefaultButton type="button" textId="increaseStage" filled onClick={handleIncreaseStage} />
            <DefaultButton type="button" textId="justCancel" onClick={toggleIncreaseModal} />
          </div>
        </BasicModal>

        <BasicModal captionId="closeChallenge" isOpen={isCloseModalOpened} onRequestClose={toggleCloseModal}>
          <CloseChallengeForm challengeId={challengeId} onRequestClose={toggleCloseModal} />
        </BasicModal>
      </PageContentPreloader>

      <style jsx global>
        {staticStyles}
      </style>

      <style jsx global>
        {dynamicStyles}
      </style>
    </PageLayout>
  );
};

BoUserChallengePage.propTypes = {
  history: PropTypes.object.isRequired,
  getUserChallenge: PropTypes.func.isRequired,
  userChallenge: PropTypes.object,
  userChallengeAreLoaded: PropTypes.bool.isRequired,
  theme: PropTypes.object,
  perms: PropTypes.object.isRequired,
  increaseStage: PropTypes.func.isRequired,
};

BoUserChallengePage.defaultProps = {
  userChallenge: {},
  theme: {},
};

export default compose(
  withRouter,
  withTheme(),
  connect(
    state => ({
      userChallenge: state.backoffice.proptrading.userChallenge,
      userChallengeAreLoaded: state.backoffice.proptrading.userChallengeAreLoaded,
      perms: state.user.profile.perms,
    }),
    {
      getUserChallenge: id => boGetUserChallenge.request(id),
      increaseStage: id => boIncreaseUserChallenge.request(id),
    }
  )
)(BoUserChallengePage);
